import $ from 'jquery'
import Swiper, { Navigation, Pagination } from 'swiper'
// import Swiper styles
import { lockScreen, unlockScreen } from './screenLocker'

// configure Swiper to use modules
Swiper.use([Navigation, Pagination])

const popupSwiper01 = new Swiper('.js-popup-swiper-gallery', {
  autoHeight: false, //enable auto height
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.popup-slider__button-next',
    prevEl: '.popup-slider__button-prev',
  },
})

/* !jsGalleryModal
---------------------------------------------------------- */
const jsGalleryModal = function () {
  const $btnOpen = $('.js-gallery-open-modal')
  const $popUp = $('.js-gallery-modal')
  const $btnClose = $('.js-close-popup')
  if ($btnOpen.length) {
    $btnOpen.each(function () {
      const $this = $(this)
      // const $btnOpen = $this.find('.js-open-popup');
      $this.on('click', function () {
        const $dataSlider = $this.data('image')
        $popUp.addClass('-is-active')
        lockScreen()
        popupSwiper01.slideTo($dataSlider - 1, 500, function () {

        })

        return false
      })

      $btnClose.on('click', function () {
        $popUp.removeClass('-is-active')
        unlockScreen()
        return false
      })
    })
  }

  // $(document).on('click touchend', function (e) {
  //   if($(e.target).closest('.sec-owner-feature').length === 0
  //     && $(e.target).closest('.mld-content__inner').length === 0
  //     && $(e.target).closest('.swiper-button-prev').length === 0
  //     && $(e.target).closest('.swiper-button-next').length === 0) {

  //     if(!dragging){
  //       if($popUp.hasClass('is-active')){
  //         $popUp.removeClass('is-active');
  //       }
  //     }
  //   }
  // });
}

const initGalleryModal = () => {
  // popupSwiper01()
  jsGalleryModal()
}

export default initGalleryModal
